<template>
  <div class="flex flex-col pt-9 bg-white min-h-[1600px]">
    <BreadCrumb text="主页/产品方案/模组方案" />
    <SectionBar text="模组方案产品信息"/>

    
    <div
      class="flex flex-col mt-10 mx-14 w-10/12 text-lg font-light text-center text-black whitespace-nowrap max-md:max-w-[1068px]">
      <div class="flex gap-5 items-start self-start ml-2.5 max-md:flex-wrap">
        <div>全部</div>
        <div class="flex flex-col">
          <div>电容式指纹</div>
          <div class="shrink-0 self-center mt-2 h-1.5 bg-black w-[63px]"></div>
        </div>
        <div class="flex-auto">underglass光学指纹</div>
        <div>超声波指纹</div>
        <div class="flex-auto">3D结构光方案</div>
        <div>TOF方案</div>
      </div>
      <img loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/58d833241b0793d0b6947ec39f1b0d04ce48ded80ddf03610bf2f027d25c7f7f?"
        class="self-center w-full border border-black border-solid max-w-[1381px] max-md:max-w-full" />
      <div class=" invisible self-start px-2.5 py-1.5 mt-4 text-sm rounded-md border border-black border-solid">
        导出CSV
      </div>


      <div
        class="self-start inline-flex gap-5 self-center justify-between px-16 py-4 mt-4 border-b border-black bg-stone-50 max-md:flex-wrap max-md:px-5 w-10/12 max-md:max-w-full">
        <div>实物图片</div>
        <div>指纹识别组模型号</div>
        <div>指纹传感器型号</div>
        <div>算法MCU型号</div>
        <div>点阵</div>
        <div>表面工艺</div>
        <div>特点说明</div>
      </div>

      <ProductRow
      v-for="(product, key) in products" :key="key"
      :imageSrc="product.imageSrc"
      :items="product.items"
    />

    </div>
    
  </div>
</template>

<script>
import SectionBar from '@/components/SectionBar.vue';
import BreadCrumb from '@/components/BreadCrumb.vue'
import ProductRow from '../ProductRow.vue';

export default {
  name: 'ProductPage',
  components:{
    SectionBar,
    ProductRow,
    BreadCrumb, 
  },

  data(){
    return {
      products: [
        {
          imageSrc: "./images/pdim/pd1.png",
          items: [
            { name: 'modelNumber', value: 'GYWM028' },
            { name: 'sensorModel', value: 'GF1208DL1' },
            { name: 'mcuModel', value: 'G6451PBNI' },
            { name: 'resolution', value: '108*88' },
            { name: 'surfaceTreatment', value: '黑色高亮' },
            { name: 'coverMaterial', value: '玻璃盖板' },
          ]
        },
        {
          imageSrc: "./images/pdim/pd2.png",
          items: [
            { name: 'modelNumber', value: 'GYWM028' },
            { name: 'sensorModel', value: 'GF1208DL1' },
            { name: 'mcuModel', value: 'G6451PBNI' },
            { name: 'resolution', value: '108*88' },
            { name: 'surfaceTreatment', value: '黑色高亮' },
            { name: 'coverMaterial', value: '玻璃盖板' },
          ]
        },
        {
          imageSrc: "./images/pdim/pd3.png",
          items: [
            { name: 'modelNumber', value: 'GYWM028' },
            { name: 'sensorModel', value: 'GF1208DL1' },
            { name: 'mcuModel', value: 'G6451PBNI' },
            { name: 'resolution', value: '108*88' },
            { name: 'surfaceTreatment', value: '黑色高亮' },
            { name: 'coverMaterial', value: '玻璃盖板' },
          ]
        },
        {
          imageSrc: "./images/pdim/pd4.png",
          items: [
            { name: 'modelNumber', value: 'GYWM028' },
            { name: 'sensorModel', value: 'GF1208DL1' },
            { name: 'mcuModel', value: 'G6451PBNI' },
            { name: 'resolution', value: '108*88' },
            { name: 'surfaceTreatment', value: '黑色高亮' },
            { name: 'coverMaterial', value: '玻璃盖板' },
          ]
        },
        {
          imageSrc: "./images/pdim/pd5.png",
          items: [
            { name: 'modelNumber', value: 'GYWM028' },
            { name: 'sensorModel', value: 'GF1208DL1' },
            { name: 'mcuModel', value: 'G6451PBNI' },
            { name: 'resolution', value: '108*88' },
            { name: 'surfaceTreatment', value: '黑色高亮' },
            { name: 'coverMaterial', value: '玻璃盖板' },
          ]
        },
        {
          imageSrc: "./images/pdim/pd6.png",
          items: [
            { name: 'modelNumber', value: 'GYWM028' },
            { name: 'sensorModel', value: 'GF1208DL1' },
            { name: 'mcuModel', value: 'G6451PBNI' },
            { name: 'resolution', value: '108*88' },
            { name: 'surfaceTreatment', value: '黑色高亮' },
            { name: 'coverMaterial', value: '玻璃盖板' },
          ]
        },
        {
          imageSrc: "./images/pdim/pd7.png",
          items: [
            { name: 'modelNumber', value: 'GYWM028' },
            { name: 'sensorModel', value: 'GF1208DL1' },
            { name: 'mcuModel', value: 'G6451PBNI' },
            { name: 'resolution', value: '108*88' },
            { name: 'surfaceTreatment', value: '黑色高亮' },
            { name: 'coverMaterial', value: '玻璃盖板' },
          ]
        },
      ]
    }
  }
};

</script>